import * as React from 'react'

interface UseIntersectionObserverOptions {
  enabled?: boolean
  rootMargin?: string
  threshold?: number | number[]
  onIntersect: () => void
}

export function useIntersectionObserver({
  enabled = true,
  rootMargin = '0px',
  threshold = 0,
  onIntersect,
}: UseIntersectionObserverOptions) {
  const [node, setNode] = React.useState<HTMLElement | null>(null)
  const callbackRef = React.useRef(onIntersect)
  React.useEffect(() => {
    callbackRef.current = onIntersect
  }, [onIntersect])

  React.useEffect(() => {
    if (!enabled || !node) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) callbackRef.current()
      },
      { rootMargin, threshold },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [enabled, node, rootMargin, threshold])

  return setNode
}
